/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type EditComponentTranslationQueryRendererQueryVariables = {
    component: string;
    lang: string;
};
export type EditComponentTranslationQueryRendererQueryResponse = {
    readonly viewer: {
        readonly userId: string;
    } | null;
    readonly translation: {
        readonly text: string | null;
    } | null;
};
export type EditComponentTranslationQueryRendererQuery = {
    readonly response: EditComponentTranslationQueryRendererQueryResponse;
    readonly variables: EditComponentTranslationQueryRendererQueryVariables;
};



/*
query EditComponentTranslationQueryRendererQuery(
  $component: String!
  $lang: String!
) {
  viewer {
    userId
  }
  translation(component: $component, lang: $lang) {
    text
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "component"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lang"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "component",
        "variableName": "component"
      },
      {
        "kind": "Variable",
        "name": "lang",
        "variableName": "lang"
      }
    ],
    "concreteType": "Translation",
    "kind": "LinkedField",
    "name": "translation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditComponentTranslationQueryRendererQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditComponentTranslationQueryRendererQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "086d109b1ee61cb4b393f29a6447425a",
    "id": null,
    "metadata": {},
    "name": "EditComponentTranslationQueryRendererQuery",
    "operationKind": "query",
    "text": "query EditComponentTranslationQueryRendererQuery(\n  $component: String!\n  $lang: String!\n) {\n  viewer {\n    userId\n  }\n  translation(component: $component, lang: $lang) {\n    text\n  }\n}\n"
  }
};
})();
(node as any).hash = '84c7f88b4702169462b30d052f587353';
export default node;
